
/** vendor */
import React, { useState } from 'react'
import { TrashIcon } from '@heroicons/react/solid'

import { IMG_URL, PLACEHOLDER_IMG } from '../../../constants/ApiConfiguration'


export default function IngredientListItem({ ingredient, onRemove = () => {} }) {

    /**
     * Handlers
     */
    const handleRemoveIngredient = async e => {
        e.preventDefault()
        onRemove(ingredient)
    }

    const button = <TrashIcon className="h-6 w-6 text-an_orange cursor-pointer" onClick={handleRemoveIngredient} />

    return (
        <div className="py-2 min-w-full" key={ingredient.value}>
            <div className="flex items-center space-x-4 w-full">
                <div className="flex-shrink-0">
                    <img 
                        className="w-8 h-8 rounded-full border border-an_green-dark overflow-hidden" 
                        src={ingredient?.image ? IMG_URL + '/' + ingredient?.image : PLACEHOLDER_IMG} 
                        alt="ingredient image" 
                    />
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-light text-black">
                        {ingredient.name}
                    </p>
                </div>
                <div className="inline-flex items-center text-base font-semibold text-black">
                    { button }
                </div>
            </div>
        </div>
    )
}